import { TypeClass } from "../common";
/**
 * key:页面路由； value: 对应页面的实例对象名
 */
const pageInstanceMap = {
  "/wt-shopping-cart": "WtCartInstance", // 购物车
  "/wt-order-list": "WtOrderListInstance", // 订单
  "/wt-coupon-redeem-home": "WtCouponRedeemInstance" // 优惠券兑换扫码
};

// 方案一 字符串逗号拆分
export function splitParams(str: string): string[] {
  return str.split(",");
}

// 方案二 解析 {url:"url", params:[1,"a"]} 或者 {url:"url", params:1}
export function parseJsonParams(param: any): string[] {
  let res: any = {};
  if (TypeClass.isString(param)) {
    res = JSON.parse(param);
  } else if (TypeClass.isObject(param)) {
    res = param;
  }
  return [
    res.url,
    ...(TypeClass.isArray(res.params) ? res.params : [res.params])
  ];
}

// 调用实例方法
export function callVueInstanceMethod(url = "", ...params) {
  try {
    url = url.replace(location.origin, "");
    const pageInstance = window[pageInstanceMap[url]] as any;
    return pageInstance.manualExecute(...params);
  } catch (e) {
    console.log(e);
  }
  return null;
}

/**
 * 提供app的刷新方法
 * 支持
 * 方案一，url参数可能是逗号隔开的字符串，需要逗号切分，一个值为url，第二个值为指定参数
 * 方案二，json字符串 {url:"url", params:1}
 * @param url 页面地址
 */
export function refreshForApp(url: string) {
  console.log("refreshForApp", url);
  if (!url) return null;
  try {
    // 执行方案二
    return callVueInstanceMethod(...parseJsonParams(url));
  } catch (e) {
    // 执行方案一
    return callVueInstanceMethod(...splitParams(url));
  }
}
